import { createSlice } from "@reduxjs/toolkit";
import {
  DeletetUser,
  GetAllUsersName,
  GetUserInfo,
  GetUserPermissions,
  GetUserStatusTable,
  GetUsers,
  postUser,
  postUserPermissions,
  GetLogs
} from "../Actions/userStatusService";

const initialState = {
  token: "",
  error: "",
  code: "",
  status: "",
  loading: false,
  userData: [],
  userKyc: {},
  custAccData: [],
  userNames: [],
  userInformation: {},
  userPermissions: [],
};
const userStatusReducer = createSlice({
  name: "userStatus",
  initialState,
  reducers: {},
  extraReducers: {
    [GetAllUsersName.pending]: (state, action) => {
      state.loading = true;
    },
    [GetAllUsersName.fulfilled]: (
      state,
      { payload: { status, data, message, code } }
    ) => {
      state.loading = false;
      if (code === 200 && data) {
        state.userNames = data;
        state.message = message;
        state.status = status;
        state.code = code;
      } else {
        state.userNames = [];
        state.error = message;
        state.status = status;
        state.code = code;
      }
    },

    [GetAllUsersName.rejected]: (state, action) => {
      state.loading = false;
    },

    [GetUserStatusTable.pending]: (state, action) => {
      state.loading = true;
    },
    [GetUserStatusTable.fulfilled]: (
      state,
      { payload: { statusCode, data, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200 && data) {
        state.userData = data;
        state.message = message;
        state.code = statusCode;
      } else {
        state.userData = [];
        state.error = message;
        state.code = statusCode;
      }
    },
    [GetUserStatusTable.rejected]: (state, action) => {
      state.loading = false;
    },
    [postUser.pending]: (state, action) => {
      state.loading = true;
    },
    [postUser.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 201) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [postUser.rejected]: (state, action) => {
      state.loading = false;
    },
    [postUserPermissions.pending]: (state, action) => {
      state.loading = true;
    },
    [postUserPermissions.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 201) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [postUserPermissions.rejected]: (state, action) => {
      state.loading = false;
    },
    [GetUsers.pending]: (state, action) => {
      state.loading = true;
    },
    [GetUsers.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.users = data;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [GetUsers.rejected]: (state, action) => {
      state.loading = false;
    },
    [GetUserInfo.pending]: (state, action) => {
      state.loading = true;
    },
    [GetUserInfo.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.userInformation = data;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [GetUserInfo.rejected]: (state, action) => {
      state.loading = false;
    },
    [GetUserPermissions.pending]: (state, action) => {
      state.loading = true;
    },
    [GetUserPermissions.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.userPermissions = data;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [GetUserPermissions.rejected]: (state, action) => {
      state.loading = false;
    },
    
    [DeletetUser.pending]: (state, action) => {
      state.loading = true;
    },
    [DeletetUser.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [DeletetUser.rejected]: (state, action) => {
      state.loading = false;
    },


    [GetLogs.pending]: (state, action) => {
      state.loading = true;
    },
    [GetLogs.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;

      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [GetLogs.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default userStatusReducer.reducer;
